import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Layout from "../components/sidebarPro";
import styles from '../assets/css/start.module.css';
import DropdownGetLevels from "../components/start/dropDownGetLevels";
import DropdownLesson from "../components/start/dropDownLessons";
import DropDownBooks from "../components/start/dropDownBooks";
import Footer from "../components/footer/Footer";
import ErrorModal from "../components/modals/loginErrorModal";
import { createGame, createGameLearn } from "../api/requests";
import Head from "next/head";
import ButtonLoading from "../components/buttonLoading";
import useTranslation from "next-translate/useTranslation";
import TokenError from "../components/modals/tokenError";

var Learn = function Learn() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  var router = useRouter();
  var levels = ['Level 1 (Picture & Synonym for English Words)', 'Level 2 (Missing Words in English Sentence)', 'Level 3 (Missing Words in Farsi Sentence)', 'Level 4 (Synonym for Farsi Words)'];
  var levelsFa = ['مرحله ۱ (عکس و مترادف برای لغات انگلیسی)', 'مرحله ۲ (جای‌خالی در جملات انگلیسی)', 'مرحله ۳ (جای‌خالی در جملات فارسی)', 'مرحله ۴ (مترادف برای لغات فارسی)'];

  var _useState = useState([]),
      books = _useState[0],
      setBooks = _useState[1];

  var _useState2 = useState([]),
      lessons = _useState2[0],
      setLessons = _useState2[1];

  var _useState3 = useState({
    code: null,
    name: null
  }),
      selectedBook = _useState3[0],
      setSelectedBook = _useState3[1];

  var _useState4 = useState({
    code: null,
    name: null
  }),
      selectedLesson = _useState4[0],
      setSelectedLesson = _useState4[1];

  var _useState5 = useState(null),
      selectedType = _useState5[0],
      setSelectedType = _useState5[1];

  var _useState6 = useState(3),
      learnType = _useState6[0],
      setLearnType = _useState6[1];

  var _useState7 = useState({
    level: false,
    book: false,
    lesson: false
  }),
      validated = _useState7[0],
      setValidated = _useState7[1];

  var _useState8 = useState(null),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = useState(false),
      getBooksLoading = _useState9[0],
      setGetBooksLoading = _useState9[1];

  var _useState10 = useState(false),
      getLessonsLoading = _useState10[0],
      setGetLessonsLoading = _useState10[1];

  var _useState11 = useState(''),
      learnFirstTimeUser = _useState11[0],
      setLearnFirstTimeUser = _useState11[1];

  var defaultSelectedLevel = {
    fa: 'مرحله خود را انتخاب کنید',
    en: 'Choose Your Level'
  };
  var defaultSelectedBook = {
    fa: 'کتاب خود را انتخاب کنید',
    en: 'Choose Your Book'
  };
  var defaultSelectedLesson = {
    fa: 'درس خود را انتخاب کنید',
    en: 'Choose Your Lesson'
  };

  var _useState12 = useState(false),
      show2 = _useState12[0],
      setShow2 = _useState12[1];

  var toggle2 = function toggle2() {
    return setShow2(!show2);
  };

  useEffect(function () {
    // localStorage.setItem('CellPhoneNum', CellPhoneNum);
    var learnFirstTimeUserConst = localStorage.getItem('learnFirstTimeUser'); // console.log("learnFirstTimeUserConst",learnFirstTimeUserConst)

    if (!learnFirstTimeUserConst || learnFirstTimeUserConst !== '4') {
      localStorage.setItem('learnFirstTimeUser', 0);
      setLearnFirstTimeUser(0);
    } else {
      setLearnFirstTimeUser(learnFirstTimeUserConst);
    }
  }, []);
  useEffect(function () {
    setSelectedBook({
      code: null,
      name: isRTL ? defaultSelectedBook.fa : defaultSelectedBook.en
    });
    setValidated(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        book: false
      });
    });
  }, [selectedType]);
  useEffect(function () {
    setSelectedLesson({
      code: null,
      name: isRTL ? defaultSelectedLesson.fa : defaultSelectedLesson.en
    });
    setValidated(_objectSpread(_objectSpread({}, validated), {}, {
      lesson: false
    }));
  }, [selectedBook]);

  var _useState13 = useState(null),
      error = _useState13[0],
      setError = _useState13[1];

  var _useState14 = useState(false),
      show = _useState14[0],
      setShow = _useState14[1];

  var toggle = function toggle() {
    return setShow(!show);
  };

  var startGame = function startGame() {
    var Counter = localStorage.getItem('Counter');
    var Username = localStorage.getItem('Username');
    var token = localStorage.getItem('token');

    if (Username && token) {
      // if validation is passed create and start the game
      if (setValidatedStyle()) {
        createGameLearn(selectedType, selectedBook.code, selectedLesson.id, token).then(function (res) {
          // console.log("createGame Learn res",res);
          var learnId = res.data;
          router.push({
            pathname: '/learnFlashcards',
            query: {
              data: [Counter, learnId, selectedLesson.id, selectedType, learnType]
            }
          });
        })["catch"](function (err) {
          console.log("createLearn error:", {
            err: err
          });
          setLoading(false);
        });
        localStorage.setItem('learnFirstTimeUser', 4);
        setLearnFirstTimeUser(4);
      } else {
        var _error = Object.entries(validated).filter(function (item) {
          return !item[1];
        });

        setError(_error[0]);
        setShow(true);
      }
    } else {
      setError(["login", false]);
      setShow(true);
      setLoading(false);
    }
  };

  var setValidatedStyle = function setValidatedStyle() {
    var isValidated = Object.entries(validated).filter(function (item) {
      return item[1];
    });
    return isValidated.length === 3;
  };

  return /*#__PURE__*/_jsxs(Layout, {
    page: "learn",
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: "Learn - wow kanoon"
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        href: "/images/logos/favicon.png"
      })]
    }), /*#__PURE__*/_jsx(TokenError, {
      show: show2,
      toggle: toggle2,
      redirect: 'learn'
    }), /*#__PURE__*/_jsx(ErrorModal, {
      error: error,
      show: show,
      toggle: toggle,
      redirect: 'learn'
    }), /*#__PURE__*/_jsxs("div", {
      className: "d-flex justify-content-center flex-column align-items-center ".concat(styles.start),
      children: [/*#__PURE__*/_jsx(DropdownGetLevels, {
        classes: {
          bg: styles.first,
          arrow: styles.firstArrowDown
        },
        defaultSelected: defaultSelectedLevel,
        data: isRTL ? levelsFa : levels,
        setBooks: setBooks,
        setSelectedType: setSelectedType,
        setValidated: setValidated,
        setError: setError,
        setShow: setShow,
        gameFirstTimeUser: learnFirstTimeUser,
        setGameFirstTimeUser: setLearnFirstTimeUser,
        mode: 'learn',
        setGetBooksLoading: setGetBooksLoading
      }), /*#__PURE__*/_jsx(DropDownBooks, {
        classes: {
          bg: selectedType ? styles.second : styles.grey,
          arrow: selectedType ? styles.secondArrowDown : styles.greyArrowDownLeft
        },
        mode: 'learn',
        defaultSelected: defaultSelectedBook,
        data: books,
        setLessons: setLessons,
        setSelectedBook: setSelectedBook,
        selectedBook: selectedBook,
        setValidated: setValidated,
        setError: setError,
        setShow: setShow,
        gameFirstTimeUser: learnFirstTimeUser,
        setGameFirstTimeUser: setLearnFirstTimeUser,
        getBooksLoading: getBooksLoading,
        setGetLessonsLoading: setGetLessonsLoading,
        setShow2: setShow2
      }), /*#__PURE__*/_jsx(DropdownLesson, {
        classes: {
          bg: selectedBook && selectedBook.code ? styles.third : styles.grey,
          arrow: selectedBook && selectedBook.code ? styles.thirdArrowDown : styles.greyArrowDownRight
        },
        data: lessons,
        defaultSelected: defaultSelectedLesson,
        setSelectedLesson: setSelectedLesson,
        selectedLesson: selectedLesson,
        setValidated: setValidated,
        setError: setError,
        setShow: setShow,
        gameFirstTimeUser: learnFirstTimeUser,
        setGameFirstTimeUser: setLearnFirstTimeUser,
        mode: 'learn',
        setLearnType: setLearnType,
        getLessonsLoading: getLessonsLoading
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.startWrapper,
        children: [learnFirstTimeUser == 3 && /*#__PURE__*/_jsx("div", {
          className: styles.toolTip,
          children: /*#__PURE__*/_jsx("p", {
            className: styles.toolTipText,
            children: t('start:Now you can start the game!')
          })
        }), /*#__PURE__*/_jsx("div", {
          onClick: loading ? undefined : startGame,
          className: "".concat(styles.menuItem, " ").concat(setValidatedStyle() ? styles.redBg : styles.greyStart),
          children: loading ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(ButtonLoading, {}), /*#__PURE__*/_jsx("span", {
              children: "loading"
            })]
          }) : /*#__PURE__*/_jsx("p", {
            children: isRTL ? 'شروع' : 'Start'
          })
        })]
      }), /*#__PURE__*/_jsx("img", {
        className: styles.missile,
        src: "/images/start/missile.svg"
      })]
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};

export var __N_SSG = true;
export default Learn;